import withDisplayName from 'bz-utilities/hoc/display-name';

import { Suspense } from 'react';

import Fallback from './controls/fallback';

export default (Component) =>
  withDisplayName(
    (props) => (
      <Suspense fallback={<Fallback />}>
        <Component {...props} />
      </Suspense>
    ),
    'LazyWrapper'
  );
